export default __webpack_public_path__ + "static/media/itc.2605ebfa.png";